function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import "./permissions.scss";
import { permissionsMenu } from "./components/data";
import ListUsers from "./components/ListUsers";
import PermissionsMenu from "./components/PermissionsMenu";
import PermissionActions from "./components/PermissionActions";

var Permissions = function Permissions(props) {
  var admins = props.admins,
      token = props.token;

  var _React$useState = React.useState(admins),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      users = _React$useState2[0],
      setUsers = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      activeUser = _React$useState4[0],
      setActiveUser = _React$useState4[1];

  var _React$useState5 = React.useState(permissionsMenu[0]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      activePermission = _React$useState6[0],
      setActivePermission = _React$useState6[1];

  var emptyBlock = function emptyBlock(text) {
    return /*#__PURE__*/React.createElement("div", {
      className: "card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body emptyCardBody"
    }, /*#__PURE__*/React.createElement("h4", null, text)));
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement(ListUsers, {
    activeUser: activeUser,
    setActiveUser: setActiveUser,
    users: users
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-9"
  }, activeUser ? /*#__PURE__*/React.createElement("div", {
    className: "card cntMenu"
  }, /*#__PURE__*/React.createElement(PermissionsMenu, {
    activeUser: activeUser,
    activePermission: activePermission,
    setActivePermission: setActivePermission,
    token: token,
    setUsers: setUsers,
    setActiveUser: setActiveUser
  }), activeUser.is_super_admin ? emptyBlock("Este ejecutivo tiene todos los permisos.") : /*#__PURE__*/React.createElement(PermissionActions, {
    activePermission: activePermission,
    activeUser: activeUser,
    token: token,
    setUsers: setUsers,
    setActiveUser: setActiveUser
  })) : emptyBlock("Seleccione Ejecutivo")));
};

export default Permissions;